import { categoryCards } from "@/mocks/anime";

const counts: Record<string, string> = {
  搞笑番: "180+ 部",
  沙雕动画: "150+ 部",
  解压日常: "160+ 部",
  治愈番: "140+ 部",
};

export default function Categories() {
  return (
    <section id="categories" className="bg-background-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-8 md:mb-12">
          <span className="inline-flex items-center gap-1.5 text-primary-600 font-bold text-sm">
            <i className="ri-grid-fill text-lg"></i>
            主题分类
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-900">
            按心情挑番，想笑就笑
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            搞笑番、沙雕动画、解压日常、治愈番四大类，分类清晰好挑选，
            今天想怎么乐呵，就怎么选。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {categoryCards.map((cat) => (
            <a
              key={cat.key}
              href="#trending"
              className="group relative rounded-2xl overflow-hidden bg-background-50 hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={cat.img}
                  alt={`${cat.title} - 小狗看番沙雕动画合集`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5 flex items-end justify-between gap-2">
                  <div>
                    <h3 className="font-heading text-lg md:text-xl text-background-50">
                      {cat.title}
                    </h3>
                    <span className="text-xs text-background-200">{counts[cat.key]}</span>
                  </div>
                  <span className="w-9 h-9 rounded-full bg-background-50/95 text-primary-600 flex items-center justify-center shrink-0">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
              <p className="p-4 md:p-5 text-sm text-foreground-700 leading-relaxed">{cat.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}